import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledIntentSelectedTopicView = styled(FlexColumn)`
    width: 100%;
`;

export const StyledIntentSelectedTopicHeaderBlock = styled.div`
    display: flex;
    height: 36px;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 8px 24px;
`;

export const StyledHeaderTitle = styled.div`
    display: flex;
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["500"])};
    font-size: 16px;
`;

export const StyledUpgradeBtn = styled(Button)`
    div {
        color: ${colorsPalettes.indigo["300"]} !important;
    }
`;

export const StyledHeaderButton = styled.div`
    display: flex;
`;

export const StyledExtraTopicAmount = styled.span<{ hasExtraTopic: boolean }>`
    color: ${({ hasExtraTopic }) => (hasExtraTopic ? colorsPalettes.indigo["300"] : colorsPalettes.carbon["500"])};
`;
